/* STYLE+ V3.4.1 — OPTION A; preserve cart MORE YOU branding and improve reminder layout.
   Read existing product-page Gift Box state/PNG; NEVER add a product/discount in this mode.
   Matching product-color cart popup preserved.
   Existing V3.3 real gift code remains dormant unless deliberately enabled.

   STYLE+ V3.3 — Existing product-page Gift Box is the only eligibility source.
   Matching popup colors work independently. Real auto-gift is OFF by default.
   A real Shopify gift product + valid automatic discount are mandatory before enable.
   This never edits protected Shopify Basic checkout markup.
*/
(() => {
  'use strict';
  if (window.__stylePlusV33Loaded) return;
  window.__stylePlusV33Loaded = true;
  const popup = document.getElementById('cart-notification');
  const popupProduct = document.getElementById('cart-notification-product');
  const root = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
  const url = path => root + path.replace(/^\//, '');
  let conf = {};
  try { conf = JSON.parse(document.getElementById('sp-v33-system')?.textContent || '{}'); } catch (_) {}
  const autoGift = conf.autoGift === true;
  const colors = ['gold','silver','blue','red','brown','green'];
  const toneFromTitle = title => {
    const s = String(title || '').toLowerCase();
    if (/hair styling powder|hair powder|styling powder/.test(s)) return 'silver';
    if (s.includes('volume booster')) return 'blue';
    if (s.includes('strong hold')) return 'red'; // deep crimson, NEVER pink
    if (/root fix|hair growth serum/.test(s)) return 'green';
    if (/beard fix|beard serum/.test(s)) return 'brown';
    return 'gold';
  };
  const setPopupTone = () => {
    if (!popup || !popupProduct) return;
    const el = popupProduct.querySelector('.cart-notification-product__name');
    if (!el) return;
    const tone = toneFromTitle(el.textContent);
    if (colors.includes(tone)) popup.dataset.spTone = tone;
  };
  const getJSON = async (path, options = {}) => {
    const r = await fetch(url(path), { credentials:'same-origin', cache:'no-store', ...options });
    const j = await r.json();
    if (!r.ok) throw new Error(j.description || j.message || `HTTP ${r.status}`);
    return j;
  };
  const cartGet = () => getJSON('cart.js');
  const cartPost = (path, data) => getJSON(path, {
    method:'POST', headers:{ 'Content-Type':'application/json', Accept:'application/json' },
    body:JSON.stringify(data)
  });
  const isOwnGift = item => String(item.properties?._sp_v33_gift || '') === '1';
  const pageCache = new Map();
  const previewId = new URLSearchParams(location.search).get('preview_theme_id');
  const currentSource = (() => {
    const tag = document.querySelector('script[data-sp-gift-source]');
    if (!tag) return null;
    try { return JSON.parse(tag.textContent); } catch (_) { return null; }
  })();
  const sourceFor = item => {
    const productId = String(item.product_id);
    if (currentSource && String(currentSource.productId) === productId) return Promise.resolve(currentSource);
    if (pageCache.has(productId)) return pageCache.get(productId);
    const promise = (async () => {
      const raw = item.url || (item.handle ? url('products/' + encodeURIComponent(item.handle)) : null);
      if (!raw) throw new Error('Product URL missing for gift lookup');
      const productURL = new URL(raw, location.origin);
      if (productURL.origin !== location.origin || !/\/products\//.test(productURL.pathname)) throw new Error('Invalid product URL');
      productURL.search = '';
      if (previewId) productURL.searchParams.set('preview_theme_id', previewId);
      const resp = await fetch(productURL, { credentials:'same-origin', cache:'no-store' });
      if (!resp.ok) throw new Error('Gift source product page HTTP ' + resp.status);
      const doc = new DOMParser().parseFromString(await resp.text(), 'text/html');
      const tags = Array.from(doc.querySelectorAll('script[data-sp-gift-source]'));
      for (const tag of tags) {
        try {
          const data = JSON.parse(tag.textContent);
          if (String(data.productId) === productId) return data;
        } catch (_) {}
      }
      // Older product-page versions do not emit data-sp-gift-source. Their
      // existing Gift Box trigger/modal are rendered ONLY while Gift is ON
      // and the preview PNG exists. Read that existing UI, never guess from
      // the product title or a separate gift eligibility list.
      const activeTrigger = doc.querySelector('.sp14-gift-trigger[data-gift-open], .spbf-gift-trigger[data-gift-open]');
      const preview = doc.querySelector('.sp14-gift-modal-media img, .spbf-gift-modal-media img');
      if (activeTrigger && preview?.getAttribute('src')) {
        return { productId: Number(productId), giftEnabled: true,
          giftVariantId: 0, giftTitle: 'Promotional Gift',
          giftImage: preview.getAttribute('src') };
      }
      return null; // existing gift toggle OFF or PNG not uploaded = no eligibility
    })();
    pageCache.set(productId, promise);
    return promise;
  };
  const makeNote = where => {
    const id = where === 'popup' ? 'sp-v33-popup-gift' : 'sp-v33-cart-gift';
    const old = document.getElementById(id);
    if (old) return old;
    const note = document.createElement('div');
    note.id=id; note.className='sp-gift-reminder'; note.hidden=true;
    note.setAttribute('role','status'); note.setAttribute('aria-live','polite');
    if (where === 'popup') {
      const links = popup?.querySelector('.cart-notification__links');
      if (!links) return null;
      links.before(note);
    } else {
      // Keep the existing MORE YOU branding visible in the open left gutter.
      // Place the reminder WITHIN the right-hand order-summary panel, not as
      // a new sibling occupying the footer's decorative left column.
      const summary = document.querySelector('#main-cart-footer .cart__blocks');
      if (!summary) return null;
      summary.prepend(note);
    }
    return note;
  };
  const render = (desired, cart, failed = false) => {
    const list = Array.from(desired.values());
    const allFree = list.length > 0 && list.every(cfg => (cart.items || []).some(item =>
      Number(item.variant_id) === cfg.giftVariantId && Number(item.final_line_price) === 0));
    for (const where of ['popup','cart']) {
      const note = makeNote(where);
      if (!note) continue;
      note.hidden = list.length === 0;
      if (!list.length) continue;
      note.classList.toggle('sp-gift-reminder--ready',allFree);
      note.classList.toggle('sp-gift-reminder--pending',!allFree);
      note.replaceChildren();
      const first = list[0];
      if (first.giftImage) {
        const img=document.createElement('img');
        img.className='sp-gift-reminder__preview'; img.alt='Free gift preview';
        img.loading='lazy'; img.src=first.giftImage;
        note.append(img);
      } else {
        const mark=document.createElement('span'); mark.className='sp-gift-reminder__icon'; mark.textContent='✦';note.append(mark);
      }
      const copy=document.createElement('span');copy.className='sp-gift-reminder__copy';
      const title=document.createElement('strong');
      title.textContent = allFree ? "YOU'VE UNLOCKED A FREE GIFT!" : (failed ? 'GIFT DISCOUNT NOT CONFIRMED' : 'FREE GIFT OFFER');
      const small=document.createElement('small');
      small.textContent = allFree
        ? (list.length === 1 ? `${first.giftTitle} is included at no extra product charge. Complete your order to claim it.` : `${list.length} free gift items confirmed in your cart. Complete your order to claim them.`)
        : 'Gift must appear at zero product price before checkout. Please review your cart or contact STYLE+ support.';
      copy.append(title,small);note.append(copy);
    }
    return allFree || list.length === 0;
  };
  // OPTION A: non-mutating reminder for Shopify Basic.
  // Reads cart.js and product-page markup; no /cart/add, /cart/change, discounts,
  // cart attributes, checkout links or order totals are modified here.
  let reminderSerial = 0;
  const cleanName = str => String(str || '').toLowerCase().replace(/\s+/g,' ').trim();
  const setOfferNote = (where, config, count = 1) => {
    const note = makeNote(where);
    if (!note) return;
    note.hidden = !config;
    if (!config) return;
    note.classList.remove('sp-gift-reminder--ready','sp-gift-reminder--pending');
    note.replaceChildren();
    if (config.giftImage) {
      const img = document.createElement('img');
      img.className = 'sp-gift-reminder__preview';
      img.alt = 'STYLE+ gift offer preview';
      img.loading = 'lazy';
      const source = new URL(config.giftImage, location.origin);
      if (source.protocol === 'https:' || source.protocol === 'http:') img.src = source.href;
      note.append(img);
    } else {
      const icon = document.createElement('span');
      icon.className = 'sp-gift-reminder__icon';icon.textContent = '✦';note.append(icon);
    }
    const copy = document.createElement('span');copy.className='sp-gift-reminder__copy';
    const heading = document.createElement('strong');
    heading.textContent = "YOU'VE UNLOCKED A FREE GIFT!";
    const sub = document.createElement('small');
    sub.textContent = where === 'popup'
      ? 'This product qualifies for the pictured gift. Complete your order to claim it.'
      : count > 1
        ? `${count} eligible products in your cart. Complete your order to claim the pictured gift offer(s).`
        : 'Your order qualifies for this free gift. Complete your order to claim it.';
    copy.append(heading,sub);note.append(copy);
  };
  const refreshOfferOnly = async () => {
    if (autoGift) return;
    const serial = ++reminderSerial;
    try {
      const cart = await cartGet();
      const ordinary = (cart.items || []).filter(item => !isOwnGift(item));
      const results = await Promise.allSettled(ordinary.map(sourceFor));
      if (serial !== reminderSerial) return; // don't display stale popup contents
      const eligible = ordinary.map((item,i) => ({item, cfg:results[i].status === 'fulfilled' ? results[i].value : null}))
        .filter(entry => entry.cfg?.giftEnabled === true && !!entry.cfg.giftImage);
      if (/(^|\/)cart\/?$/.test(location.pathname)) {
        setOfferNote('cart', eligible[0]?.cfg || null, eligible.length);
      }
      if (!popup || !popupProduct) return;
      const popupHeading = cleanName(popupProduct.querySelector('.cart-notification-product__name')?.textContent);
      const match = eligible.find(({item}) => {
        const name = cleanName(item.product_title || item.title);
        return popupHeading && (popupHeading === name || popupHeading.includes(name) || name.includes(popupHeading));
      });
      setOfferNote('popup', match?.cfg || null);
    } catch (err) {
      console.warn('[STYLE+] Reminder-only read skipped:',err);
      setOfferNote('popup', null);
      if (/(^|\/)cart\/?$/.test(location.pathname)) setOfferNote('cart', null);
    }
  };
  let running = null;
  const failedThisPage = new Set();
  const sync = () => {
    if (!autoGift) return Promise.resolve(true);
    if (running) return running;
    running = (async () => {
      let cart = await cartGet();
      const regular = (cart.items || []).filter(item => !isOwnGift(item));
      const configs = await Promise.all(regular.map(sourceFor)); // fail-closed: don't remove gifts if source can't load
      const desired = new Map();
      configs.forEach(cfg => {
        if (!cfg || cfg.giftEnabled !== true) return;
        const id = Number(cfg.giftVariantId);
        if (!Number.isSafeInteger(id) || id <= 0) return;
        if (!desired.has(id)) desired.set(id, {giftVariantId:id,
          giftTitle:String(cfg.giftTitle||'Free Gift'),giftImage:String(cfg.giftImage||'')});
      });
      let changed = false;
      // Only touch gift lines created by THIS system, never manually added merchandise.
      for (const item of cart.items || []) {
        if (!isOwnGift(item)) continue;
        const id=Number(item.variant_id);
        if (!desired.has(id)) { await cartPost('cart/change.js',{id:item.key,quantity:0}); changed=true; }
        else if (item.quantity !== 1) { await cartPost('cart/change.js',{id:item.key,quantity:1}); changed=true; }
      }
      if (changed) cart=await cartGet();
      const newlyAdded=[];
      for (const cfg of desired.values()) {
        if (failedThisPage.has(cfg.giftVariantId)) continue;
        if ((cart.items||[]).some(item=>Number(item.variant_id)===cfg.giftVariantId)) continue;
        await cartPost('cart/add.js',{items:[{id:cfg.giftVariantId,quantity:1,properties:{_sp_v33_gift:'1'}}]});
        newlyAdded.push(cfg.giftVariantId);changed=true;
      }
      if (changed) cart=await cartGet();
      // Never leave a newly added PAID gift in someone's cart if the discount isn't active.
      let failed=false;
      for (const id of newlyAdded) {
        const items=(cart.items||[]).filter(item=>Number(item.variant_id)===id && isOwnGift(item));
        if (!items.some(item=>Number(item.final_line_price)===0)) {
          failed=true; failedThisPage.add(id);
          for (const item of items) await cartPost('cart/change.js',{id:item.key,quantity:0});
        }
      }
      if (failed) cart=await cartGet();
      const good=render(desired,cart,failed);
      if (changed && !failed && /(^|\/)cart\/?$/.test(location.pathname)) {
        location.reload(); // Dawn cart line items and total must reflect the actual server cart.
      } else if (changed || failed) {
        try {
          const parts=await getJSON('cart?sections=cart-icon-bubble');
          const html=parts['cart-icon-bubble'];
          if (html) {
            const el=new DOMParser().parseFromString(html,'text/html').querySelector('#cart-icon-bubble');
            document.getElementById('cart-icon-bubble')?.replaceWith(el || document.getElementById('cart-icon-bubble'));
          }
        } catch (_) {}
      }
      return good;
    })().catch(err => {
      console.warn('[STYLE+] Gift sync skipped (cart unchanged if source fetch fails):',err);
      return false;
    }).finally(()=>{ running=null; });
    return running;
  };
  const prepare = async () => !autoGift || await sync();
  window.StylePlusGift={prepare,sync};
  if (popupProduct) {
    let last=null;
    const onNewProduct=()=>{
      const node=popupProduct.firstElementChild;
      if (!node || node===last) return;
      last=node; setPopupTone();
      if (autoGift) void sync();
      else void refreshOfferOnly();
    };
    new MutationObserver(onNewProduct).observe(popupProduct,{childList:true});
    onNewProduct();
  }
  if (!autoGift) {
    // Cart-page initial render + Ajax quantity/removal updates.
    if (/(^|\/)cart\/?$/.test(location.pathname)) {
      void refreshOfferOnly();
      const cartItems = document.getElementById('main-cart-items');
      if (cartItems) {
        let pending;
        new MutationObserver(() => {
          clearTimeout(pending);
          pending = setTimeout(() => void refreshOfferOnly(), 220);
        }).observe(cartItems,{childList:true,subtree:true});
      }
    }
    window.addEventListener('pageshow', event => { if (event.persisted) void refreshOfferOnly(); });
    return;
  }
  // On the product page, cart and popup routes, reconcile after a normal render.
  if (/(^|\/)cart\/?$/.test(location.pathname)) void sync();
  window.addEventListener('pageshow',event=>{ if(event.persisted) void sync(); });
  const cartItems=document.getElementById('main-cart-items');
  if (cartItems) {
    let delayed;
    new MutationObserver(()=>{clearTimeout(delayed);delayed=setTimeout(()=>void sync(),350);})
      .observe(cartItems,{childList:true,subtree:true});
  }
  let checkoutBusy=false;
  const finishCheckout=async (form,href)=>{
    if (checkoutBusy) return;
    checkoutBusy=true;
    try {
      if (!(await prepare())) { location.assign(url('cart')); return; }
      if (form) {
        if (!form.querySelector('input[type="hidden"][name="checkout"]')) {
          const hidden=document.createElement('input');
          hidden.type='hidden'; hidden.name='checkout'; hidden.value='Checkout'; form.append(hidden);
        }
        HTMLFormElement.prototype.submit.call(form);
      } else location.assign(href || url('checkout'));
    } catch (err) {console.warn('[STYLE+] Gift verification failed:',err);location.assign(url('cart'));}
    finally { checkoutBusy=false; }
  };
  document.addEventListener('click',event=>{
    const target=event.target instanceof Element ? event.target : null;
    const button=target?.closest('button[name="checkout"],input[name="checkout"]');
    const link=target?.closest('.cart-notification__links a[href*="/checkout"], .cart__footer a[href*="/checkout"]');
    if (!button && !link) return;
    event.preventDefault();event.stopImmediatePropagation();
    void finishCheckout(button?.form || null,link?.href || null);
  },true);
  document.addEventListener('submit',event=>{
    const form=event.target;
    if (!(form instanceof HTMLFormElement) || !form.querySelector('[name="checkout"]')) return;
    event.preventDefault();event.stopImmediatePropagation(); void finishCheckout(form,null);
  },true);
})();
